import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { MyStore, reducers } from 'kts-platform-frame/redux';
import { create } from 'kts-scaffold-framework/utils/form';
import { Button, Drawer, Input, Form, message } from 'kts-xui';
import { Upload } from 'kts-components-antd-x4';
import { Icon } from 'antd';
import { FormInstance } from 'kts-components-antd-x4/lib/form';
import { serverDomain } from 'kts-platform-frame/entry/configUtils';
// const css = require('./index.scss');
import './index.scss';
const FormItem = Form.Item;
const formItemLayout = {
    labelCol: { span: 0 },
    wrapperCol: { span: 24 },
};

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    onClose?: () => void;
}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {
    formRef = React.createRef<FormInstance>();
    constructor(props: IProps) {
        super(props, ModulesAction);
        this.state = {
            fileList: [],
            defaultFileList: [],
            uploading: false,
            fistupload: false,
        };
    }
    beforeUpload = (file) => {
        // const isJPG = file.type === 'image/jpeg';
        const isExcel = (file.name.toLowerCase().split('.').splice(-1)[0] === 'xls') || (file.name.toLowerCase().split('.').splice(-1)[0] === 'xlsx');
        if (!isExcel) {
            message.error('只能上传.xls,.xlsx格式的文档!');
            file.status = 'error';
            this.removeFile(file);
            return false;
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error('上传文件限制2MB!');
            file.status = 'error';
            this.removeFile(file);
            return false;
        }
        this.setState(({ fileList }) => ({
            fileList: [file],
            defaultFileList: [],
            fistupload: !this.state.fistupload,
        }));
        return false; // 禁止提交 
    }
    normFile = (e) => {
        const files = Array.prototype.slice.call(e.target.files, 0, 1);
        if (Array.isArray(files)) {
            return files;
        }
        return files;
    }
    removeFile = (file) => {
        this.setState(({ fileList }) => {
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            return {
                fileList: newFileList,
            };
        });
    }
    onClose = () => {
        this.props.onClose();
    }
    onSubmit = () => {
        this.formRef.current.submit();
    }
    render() {
        // const { getFieldDecorator } = this.props.form;
        const { user } = MyStore.instance.getState();
        const { fileList } = this.state;
        const props = {
            action: '', // serverDomain() + Urls.inviteBatchNetworkCompany,
            headers: {
                Authorization: user.cToken,
                zoneUrl: serverDomain()
            },
            onRemove: this.removeFile,
            defaultFileList: [],

        };

        const Dragger = Upload.Dragger as any;
        return (
            <div className={`uploadbatchtext asideroverall`}>
                <Drawer
                    title="批量邀请"
                    onClose={this.onClose}
                    visible={true}
                    footer={
                        <div style={{ textAlign: 'right' }} >
                            <Button style={{ marginRight: 8 }} type="primary" disabled={!this.state.fileList.length} onClick={this.onSubmit} >批量邀请</Button>
                            <Button onClick={this.onClose} type="default" >关闭</Button>
                        </div>}
                >
                    <Form
                        layout='vertical'
                        ref={this.formRef}
                        labelCol={null}
                        wrapperCol={null}
                        onFinish={this.handleSubmit}
                    >
                        <FormItem style={{ paddingLeft: '10px', marginBottom: '0px' }}>
                            <a href="/template/invita_company.xls" download="批量邀请公司模板.xls" className="ml-5 uploadueracolor">下载企业列表模板</a>
                        </FormItem>
                        <FormItem
                            style={{ paddingTop: '0px' }}
                            {...formItemLayout}
                            name='dragger'
                            valuePropName='fileList'
                            getValueFromEvent={this.normFile}
                        >
                            <div className="dropbox">
                                <Dragger {...props} fileList={fileList} beforeUpload={this.beforeUpload} multiple={false} >
                                    <p className="ant-upload-drag-icon">
                                        <Icon style={{fontSize:50}} type="cloud-upload" />
                                    </p>
                                    <p className="ant-upload-text">点击或拖拽文件至此上传</p>
                                    <p className="ant-upload-hint">仅支持xls或xlsx文件格式</p>
                                </Dragger>
                            </div>
                        </FormItem>
                    </Form>
                </Drawer>
            </div>
        );
    }
    /** 提交表单 */
    private handleSubmit = (values) => {
        ModulesAction.sendUpload(values.dragger[0]);
    }
}



// WEBPACK FOOTER //
// ./src/display/platform/Network/UI.Network.Modal.Invitation.Batch.tsx